export default "__VITE_ASSET__D1ZgYrny__"